const TOKEN_KEY = 'access-token';
const USER_INFO = 'user_info'

const isLogin = () => {
  return !!sessionStorage.getItem(TOKEN_KEY);
};

const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

const setToken = (token: string) => {
  sessionStorage.setItem(TOKEN_KEY, token);
};

const removeToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
};

export { isLogin, getToken, setToken, removeToken };
